import React from 'react';
import { Link } from 'react-router-dom';
import layoutData from '../data/layout.json';

function Footer() {
  const { footer } = layoutData;

  return (
    <footer className="footer">
      <div className="container" style={{ maxWidth: '1200px' }}>
        <div className="footer-grid">
          <div>
            <h3 style={{ marginBottom: '1rem' }}>{footer.title}</h3>
            <p>{footer.tagline}</p>
            <p style={{ marginTop: '1rem' }}>{footer.description}</p>
          </div>
          <div>
            <h4 style={{ marginBottom: '1rem' }}>{footer.quickLinksTitle}</h4>
            <ul className="footer-quick-links">
              {footer.quickLinks.map((link) => (
                <li key={link.to}><Link to={link.to} className="footer-link">{link.label}</Link></li>
              ))}
            </ul>
          </div>
          <div>
            <h4 style={{ marginBottom: '1rem' }}>{footer.contactTitle}</h4>
            {footer.contacts.map((contact) => (
              <p key={contact.href}>
                {contact.label === 'Email' ? '📧' : '📞'}{' '}
                {contact.label !== 'Email' && `${contact.label}: `}
                <a href={contact.href}>{contact.text}</a>
              </p>
            ))}
          </div>
        </div>
        <div style={{ borderTop: '1px solid rgba(255,255,255,0.3)', paddingTop: '1rem', textAlign: 'center' }}>
          <p>© {new Date().getFullYear()} {footer.copyright}</p>
          <p style={{ fontSize: '0.9rem', marginTop: '0.5rem' }}>{footer.registration}</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
